export default function Logo({ height = 54, variant = "dark", className = "" }) {
  const src = variant === "white" ? "/logo-white.png" : "/logo.png";
  return (
    <img
      src={src}
      alt="SK Engineering Works — Aluminium Pressure Die Casting & Precision Components"
      style={{ height: `${height}px`, width: "auto" }}
      className={`w-auto ${className}`}
      draggable={false}
    />
  );
}
